export default __webpack_public_path__ + "static/media/youtube_thumbnail.4f38f343.png";